import { useMemo } from 'react';

import {
  PayWithLinkPagos,
  PayWithPagoMisCuentas,
  PaymentCardSelector,
  PayWithPagoFacil,
} from '../components';

import usePinsAccount from '@/hooks/usePinsAccount';
import { PAYMENT_METHODS, PAYMENT_METHODS_BY_ID } from '@/utils';

interface MethodPayment {
  component: React.ReactNode;
  isOpen: boolean;
}
export const usePaymentSelectedModal = () => {
  const { pinsData } = usePinsAccount();

  const paymentMethod: Record<string, MethodPayment> = useMemo(() => {
    return {
      [PAYMENT_METHODS.PAGO_FACIL.id]: {
        component: (
          <PayWithPagoFacil isHowTo={Boolean(pinsData.moneyToWallet)} />
        ),
        isOpen: true,
      },
      [PAYMENT_METHODS.PAGO_MIS_CUENTAS.id]: {
        component: (
          <PayWithPagoMisCuentas isHowTo={Boolean(pinsData.moneyToWallet)} />
        ),
        isOpen: true,
      },
      [PAYMENT_METHODS.LINK_PAGOS.id]: {
        component: (
          <PayWithLinkPagos isHowTo={Boolean(pinsData.moneyToWallet)} />
        ),
        isOpen: true,
      },
      [PAYMENT_METHODS.DEB_CRED.id]: {
        component: <PaymentCardSelector />,
        isOpen: true,
      },
    };
  }, [pinsData.moneyToWallet]);

  const methodPayment = useMemo(() => {
    if (!pinsData.selectedPaymentMethod) {
      return null;
    }

    const selectedMethod =
      PAYMENT_METHODS_BY_ID[pinsData.selectedPaymentMethod.id];

    return paymentMethod[selectedMethod.id] || null;
  }, [pinsData.selectedPaymentMethod, paymentMethod]);

  return { methodPayment };
};
